import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';

import { SideNavComponent } from '@layout/side-nav/side-nav.component';
import { HeaderNavComponent } from '@layout/header-nav/header-nav.component';
import { TrialBannerComponent } from '@layout/trial-banner/trial-banner.component';
import { VerificationNudgeBannerComponent } from '@layout/verification-nudge-banner/verification-nudge-banner.component';

@Component({
    selector: 'app-content-layout',
    standalone: true,
    imports: [RouterOutlet, SideNavComponent, HeaderNavComponent, TrialBannerComponent, VerificationNudgeBannerComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="content-layout">
            <app-side-nav (collapsedChange)="sidebarCollapsed.set($event)" />
            <div class="content-main" [class.sidebar-collapsed]="sidebarCollapsed()">
                <app-trial-banner />
                <app-verification-nudge-banner />
                <app-header-nav />
                <main class="content-body">
                    <router-outlet />
                </main>
            </div>
        </div>
    `,
})
export class ContentLayoutComponent {
    readonly sidebarCollapsed = signal(false);

    constructor() {
        const router = inject(Router);
        const destroyRef = inject(DestroyRef);
        const subscription = router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        });
        destroyRef.onDestroy(() => subscription.unsubscribe());
    }
}
